import { Translation } from '@jsverse/transloco';
import { VAR_NATIONAL_ID_LENGTH } from '../../../../shared/config/consts';

const fr: Translation = {
  citizen: {
    loginToContinue: 'Connectez-vous pour continuer',
  },
  location: {
    province: 'Province',
    district: 'District',
    sector: 'Secteur',
    cell: 'Cellule',
    village: 'Village',
  },
  form: {
    title: {
      addCategory: "Ajouter une Catégorie",
      editCategory: "Modifier la Catégorie",
      addAccount: "Nouveau Personnel",
      editAccount: "Modifier le Personnel",
      addInstitution: "Nouvelle Institution",
      editInstitution: "Modifier l'Institution",
      newCase: "Nouveau Cas",
      editCase: "Modifier le Cas",
      newAnnouncement: "Nouvelle Annonce",
      editAnnouncement: "Modifier l'Annonce",
      newCitizen: "Nouveau Citoyen",
      editCitizen: "Modifier le Citoyen",
      anonymousComplaint: "Plainte Anonyme",
      orientationLevel: "Niveau d'Orientation",
    },
    label: {
      firstName: "Prénom",
      middleName: "Deuxième Prénom",
      lastName: "Nom",
      documentType: "Type de document",
      documentNumber: "Numéro de document",
      name: "Nom",
      phoneNumber: "Numéro de téléphone",
      gender: "Genre",
      email: "Email",
      nationalId: "Numero d'Identité",
      province: "Province",
      district: "District",
      sector: "Secteur",
      cell: "Cellule",
      village: "Village",
      title: "Titre",
      password: "Mot de passe",
      description: "Description",
      caseType: "Type de cas",
      severity: "Gravité",
      victimsNumber: "Nombre de victimes",
      trackingLevel: "Niveau",
      estimateDays: "Jours estimés",
      primaryOrganization: "Organisation principale",
      informedOrganization: "Organisations informées",
      issueLocation: "Détails de l'emplacement",
      issueDetails: "Détails",
      orientationLevel: "Niveau de suivi du cas",
      recordingLevel: "Niveau",
      complaint: "Plainte",
      search: "Rechercher",
      goodGovernanceSection: "Section de la Bonne Gouvernance",
      rejectionReason: "Raison de la rejet",
      optional: '(Optionnel)',
    },
    placeholder: {
      documentType: "Entrer le type de document",
      documentNumber: "Entrer le numéro de document",
      name: "Entrer le nom",
      phoneNumber: "Entrer le numéro de téléphone",
      gender: "Sélectionner le genre",
      email: "Entrer l'email",
      nationalId: "Entrer le numéro d'identité",
      province: "Sélectionner la province",
      district: "Sélectionner le district",
      sector: "Sélectionner le secteur",
      cell: "Sélectionner la cellule",
      village: "Sélectionner le village",
      password: "Entrer le mot de passe",
      description: "Entrer la description",
      title: "Entrer le titre",
      complaint: "Entrer le Plainte",
      caseType: "Sélectionner le type de cas",
      severity: "Sélectionner le niveau de gravité",
      victimsNumber: "Sélectionner le nombre de victimes",
      trackingLevel: "Sélectionner le niveau de suivi",
      estimateDays: "Entrer les jours estimés",
      primaryOrganization: "Sélectionner l'organisation principale",
      informedOrganization: "Sélectionner les organisations informées",
      issueLocation: "Entrer les détails de l'emplacement",
      issueDetails: "Entrer les détails du problème",
      orientationLevel: "Sélectionner le niveau de suivi du cas",
      recordingLevel: "Sélectionner le niveau d'enregistrement",
      searchInstitution: "Rechercher ici",
      firstName: "Entrer le Prénom",
      lastName: "Entrer le Nom",
    },
    button: {
      forgotPassword: "Mot de passe oublié?",
      resetPassword: "Réinitialiser le mot de passe",
      login: "Login",
      alreadyHaveAnAccount: "Already have an account?",
      submitButton: "Submit",
      signUp: "Sign up",
      ok: "Okay",
      cancel: "Cancel",
      addCategory: "Add Category",
      addAccount: "Add Account",
      addInstitution: "Add Institution",
      newCase: "New Case",
      newAnnouncement: "New Announcement",
      newCitizen: "New Citizen",
      casesStatus: {
        closed: "Fermé",
        ongoing: "En cours",
        done: "Résolu",
        reopened: "Re-ouverte",
      },
    },
    options: {
      severity: {
        low: "Faible",
        medium: "Moyen",
        high: "Élevé",
      },
      trackingLevel: {
        district: "District",
        sector: "Secteur",
        cell: "Cellule",
        village: "Village",
      },
      victimsNumber: {
        one: "Un",
        multiple: "Multiple"
      },
    },
    errors:{
      emailPhoneRequired:'Email ou Numéro de téléphone est requis',
      invalidEmailOrPhoneNumber: 'Email ou numéro de téléphone invalide (07  XXXX XXXX)',
      passwordRequired: 'Le mot de passe est requis',
      firstIsRequired: "Le prénom est requis",
      lastIsRequired: "Le nom est requis",
      genderIsRequired:"Genre is required",
      nidIsRequired: `Le numéro d'identité doit contenir ${VAR_NATIONAL_ID_LENGTH} chiffres`,
      phoneIsRequired: "Le numéro de téléphone (07 XXXX XXXX) est requis",
      codeRequired: "Le code de vérification est requis",
    }
  },

  resetPasswordForm: {
    title: "Réinitialisez votre mot de passe",
    description: "Définissez un nouveau mot de passe pour continuer et accéder à la plateforme",
    label: {
      code: "Mot de passe actuel",
      newPassword: "Nouveau mot de passe",
    },
    placeholder: {
      code: "Entrez le mot de passe actuel",
      enterNewPassword: "Entrez le nouveau mot de passe",
    },
    button: "Confirmer le nouveau mot de passe",
  },

  casesStatus: {
    closed: "Fermé",
    ongoing: "En cours",
    done: "Résolu",
    reopened: "Re-ouverte",
    pending: "Pending",
  },

  announcementStatus: {
    published: "Publié",
    unpublished: "Expiré",
  },
  noCasesFound: 'Aucun cas trouvé',
  fetchingData: "Récupération des données...",
  editPersonalInfo: "Informations Personnelles",
  editPersonalInfoDescription: "Ces informations sont récupérées à partir de votre carte d'identité et ne peuvent pas être modifiées",
  changePassword: "Changer le mot de passe",
  changePasswordDescription: "Entrez votre mot de passe actuel pour changer votre mot de passe",
  currentPassword: "Mot de passe actuel",
  confirmPassword: "Confirmer le mot de passe",
  enterConfirmPassword: "Entrer le mot de passe de confirmation",
  enterCurrentPassword: "Entrer le mot de passe actuel",
  // MENU
  dashboard: "Tableau de bord",
  complaints: "Plainte",
  announcements: "Annonces",
  tipOffs: "Signalement",
  manage: "Gérer",
  citizens: "Citoyens",
  institutions: "Institutions",
  accounts: "Comptes",
  security: "Security",
  overview: "Aperçu",
  cases: "Cas",
  analytics: "Analyse",
  staff: "Staff",
  rolesAndPermissions: "Rôles & Permissions",
  systemSettings: "Paramètres du Système",
  tipOffCategories: "Catégorie de Signalement ",

  tipOffCategoryPage: {
    title: "TipOff Categories",
    description: "Manage tip-off categories",
    action: {
      addNewCategory: "Add Category",
    }
  },
  modal: {
    title: "Filter",
    byInstitution: "By Institution",
    clear: "Clear Filters",
    apply: "Apply Filters",
    edit: "Edit ",
    view: "View ",
    deactivate: "Deactivate",
    delete: "Delete",
  },
  noDocumentsFound: "Aucun document trouvé",
  home: "Accueil",
  quickOverview: "Aperçu rapide",
  announcement: "Annonces",
  myDashboard: "Mon tableau",
  welcome: "Bienvenue",
  tipOffCategory: "Catégorie",
  tipOffCategoryPlaceholder: "Sélectionnez une catégorie de signalement",
  newAnonymousComplaint: "Signaler anonymement",
  issueDescription: "Description du Problème",
  enterIssueDescription: "Entrer la description du problème",
  issueTitlePlaceholder: "Entrer le titre du problème",
  reportAnonymously: "Signaler anonymement",
  submitComplaint: "Soumettre Plainte",
  submitComplaintDescription: "Un compte est requis pour soumettre une plainte.",
  submitComplaintButton: "Soumettre une Plainte",
  anonymousComplaintDescription: "Aucune information personnelle requise pour soumettre.",
  anonymousComplaintNoticeTitle: "Avis",
  anonymousComplaintNoticeMessage: "Les signalements sont examinés et traités en interne par l'institution compétente. En tant que citoyen, vous ne devez pas vous attendre à un suivi ou à un contact direct de la part de l'équipe Mbaza. Si vous souhaitez une réponse ou être contacté, veuillez déposer une plainte classique.",
  newComplaint: "Nouvelle Plainte",
  closed: "Fermé",
  ongoing: "En cours",
  nationalId: "Carte d'identité",
  name: "Nom",
  phoneNumber: "Numéro de téléphone",
  gender: "Genre",
  email: "Email",
  complaintsAndCases: "Plaintes & Cas",
  searchHere: "Rechercher ici",
  underReview: "En cours de révision / Rejeté",
  myComplaints: "Mes Plaintes",
  statusOngoing: "En cours",
  statusPending: "En Attente",
  statusReOpened: "Re-ouverte",
  statusClosed: "Fermé",
  statusDone: "Résolu",
  statusRejected: "Rejeté",
  issueLocation: "Emplacement du Problème",
  district: "District",
  sector: "Sector",
  cell: "Cellule",
  village: "Village",
  selectDistrict: "Sélectionner District",
  selectSector: "Sélectionner Secteur",
  selectCell: "Sélectionner Cellule",
  selectVillage: "Sélectionner Village",
  issueDetails: "Détails du Problème",
  title: "Titre",
  complaint: "Plainte",
  complaintTitle: "Titre de la Plainte",
  typeYourComplaint: "Écrivez votre plainte",
  download: "Télécharger",
  noFilesAttached: "Aucun fichier",
  complaintDetails: "Détails de la Plainte",
  reportedOn: "Reporté le",
  close: "Fermer",
  loading: "Chargement...",
  supportingAttachments: "Documents justificatives",
  caseDetails: "Détails du Cas",
  reportedBy: "Reporté par",
  informedInstitutions: "Institutions informées",
  noOrganizationsInformed: "Aucune institution informée",
  caseTimeline: "Chronologie du Cas",
  trackingLevel: "Niveau de suivi",
  createdBy: "Créé par",
  assignedTo: "Assigné à",
  primaryOrganization: "Organisation principale",
  none: "Aucun",
  myProfile: "Mon Profil",
  profile: "Profil",
  logout: "Déconnexion",
  login: "Connexion",
  register: "Registre",
  landingPageTitle: "Bienvenue sur",
  trackComplaint: "Suivre une plainte",
  tracking: "Suivre une plainte ",
  trackingPlaceholder: "Entrez le numéro de suivi",
  trackAnotherComplaint: "Suivre une autre plainte",
  reportedAComplaint: "A signalé une plainte",
  createdACase: "A créé un cas",
  addedAComment: "A ajouté un commentaire",
  trackYourComplaint: "Suivre votre plainte",
  mostCasePerDistrict: "La plupart des cas par district",
  mostCasePerInstitution: "La plupart des cas par institutions",
  mostCasePerCategory: "La plupart des cas par catégorie",
  mostCasePerChannel: 'La plupart des cas par canal',
  caseTrendThisYear: "Tendance des cas cette année",
  casesOnTheMap: "Cas sur la carte",
  notifications: "Notifications",
  newCase: "Nouveau Cas",
  createCase: "Créer un Cas",
  nonOrientedComplaints: "Plaintes non orientées",
  filterComplaints: "Filtrer les plaintes",
  today: "Aujourd'hui",
  thisWeek: "Cette Semaine",
  thisMonth: "Ce Mois",
  thisYear: "Cette Année",
  allTime: "Tout le Temps",
  enterNamesKeyword: "Entrer les noms, mots-clés, etc...",
  retry: "Réessayer",
  urgentCases: "Cas Urgents",
  nothingToShow: "Aucun affichage",
  thisListIsEmpty: "Cette liste est vide",
  filter: "Filtrer",
  allCases: "Tous les Cas",
  selectStatus: "Sélectionner le Statut",
  selectCategory: "Sélectionner la Catégorie",
  selectOwnership: "Sélectionner la Possession",
  primaryCases: "Cas Primaire",
  secondaryCases: "Cas Secondaire",
  status: "Statut",
  type: "Type",
  filterCases: "Filtrer les Cas",
  byLocation: "Par Emplacement",
  byInstitutions: "Par Institutions",
  bySeverityAndUrgency: "Par Urgence",
  institution: "Institution",
  severity: "Gravité",
  urgency: "Urgence",
  ownership: "Propriété",
  allStatus: "Tous les Statuts",
  allTypes: "Tous les Types",
  allOwnerships: "Tous les Propriétaires",
  allDistricts: "Tous les Districts",
  allSectors: "Tous les Sectors",
  allCells: "Tous les Cellules",
  allVillages: "Tous les Villages",
  allInstitutions: "Tous les Institutions",
  allSeverities: "Tous les Gravités",
  allUrgencies: "Tous les Urgences",
  clearFilters: "Effacer les Filtres",
  filterList: "Filtrer la Liste",
  dateRange: "Date Range",
  period: "Période",
  selectHere: "Sélectionner ici",
  mostCasesPerCategory: "La plupart des cas par Catégorie",
  mostCasesPerInstitutions: "La plupart des cas par Institutions",
  mostCasesPerDistrict: "La plupart des cas par District",
  noDataAvailable: "Aucune donnée disponible",
  totalCases: "Tous les Cas",
  new: "Nouveau",
  reopened: "Re-ouverte",
  avgReactionTime: "Temps de réaction moyen",
  avgSatisfaction: "Satisfaction moyenne",
  done: "Résolu",
  casesTrendPerYear: "Tendance des cas par année",
  totalCitizens: "Total des Citoyens",
  withOngoingCases: "Avec des cas en cours",
  avgCasesPerUser: "Moyenne de cas par utilisateur",
  avgCasesPerInstitution: "Moyenne de cas par Institutions",
  female: "Femme",
  male: "Homme",
  foreigners: "Étrangers",
  newCitizen: "Nouveau Citoyen",
  createCitizen: "Créer un Citoyen",
  saveChanges: "Enregistrer les Changements",
  editCitizen: "Modifier le Citoyen",
  numberOfCases: "Nombre de cas",
  totalInstitutions: "Total des Institutions",
  institutionsWithOngoingCases: "Institutions avec des cas en cours",
  newInstitution: "Nouvelle Institution",
  addInstitution: "Ajouter une Institution",
  //TODO:update
  ongoingCases: "Cas en cours",
  closedCases: "Cas Ferme",
  resolvedCases: "Cas Resolue",
  reOpenedCases: "Cas Re-Ouvert",

  joined: "Rejoint",
  myCases: "Mes Cas",
  taggedCases: "Cas Taggués",
  organizationDetails: "Détails de l'Organisation",
  performance: "Performance",
  admin: "Admin",
  addStaff: "Ajouter un Staff",
  newStaff: "Nouveau Staff",
  systemAccounts: "Comptes Système",
  role: "Rôle",
  lastLogin: "Dernière Connexion",
  edit: "Modifier",
  addAccount: "Ajouter un Compte",
  addRole: "Ajouter un Rôle",
  usedBy: "Utilisé par",
  roles: "Rôles",
  newRole: "Nouveau Rôle",
  newAnnouncement: "Nouvelle Annonce",
  unpublish: "Dépublier",
  expiresAt: "Expire le",
  announcementTitle: "Titre de l'Annonce",
  enterTitle: "Entrer le titre",
  announcementValidity: "Validité de l'Annonce",
  expiryDate: "Date d'Expiration",
  publishAnnouncement: "Publier l'Annonce",
  yourAnnouncement: "Votre Annonce",
  announcementValidityDescription:
    "C'est la période où l'annonce sera active, si elle n'est pas définie, elle sera définie à 5 jours à partir de la date de publication",
  published: "Publié",
  unpublished: "Expiré",
  reviewComplaint: "Revoir la plainte",
  rating: "Note",
  commentsOptional: "Commentaires (Optionnel)",
  shareYourFeedback: "Partagez votre feedback...",
  reporterReview: "Revue du Reporter",
  enterNationalId: "Entrer la carte d'identité",
  continue: "Continuer",
  haveAnAccount: "Avez-vous un compte?",
  selectYourPhoneNumber: "Sélectionnez votre numéro de téléphone",
  associatedPhoneNumbers: "Numéros de téléphone associés à votre carte d'identité",
  requestVerificationCode: "Demander un code de vérification",
  verificationCode: "Code de vérification",
  verificationCodeDescription: "Vous avez reçu un code de vérification sur votre numéro de téléphone {{ phone }}",
  verifyCode: "Vérifier le code",
  completeYourRegistration: "Compléter votre inscription",
  completeRegistrationDescription: "Complétez vos informations pour compléter votre inscription",
  firstName: "Prénom",
  lastName: "Nom",
  enterEmail: "Entrer l'email",
  password: "Mot de passe",
  enterPassword: "Entrer le mot de passe",
  signUp: "S'inscrire",
  emailOrPhone: "Email / Téléphone",
  enterEmailOrPhoneNumber: "Entrer un email ou un numéro de téléphone",
  forgotPassword: "Mot de passe oublié?",
  resetPassword: "Réinitialiser le mot de passe",
  goToLogin: "Aller à la connexion",
  code: "Code",
  enterCode: "Entrer le code",
  newPassword: "Nouveau mot de passe",
  enterNewPassword: "Entrer le nouveau mot de passe",
  confirmPasswordReset: "Confirmer la réinitialisation du mot de passe",
  noNotificationsFound: "Aucune notification trouvée",
  selectInstitution: "Sélectionner une Institution",
  manageCaseCategoriesDescription: "Gérer les catégories de cas disponibles et leurs descriptions.",
  caseCategories: "Catégories de cas",
  addCaseCategory: "Ajouter une catégorie de cas",
  updateCaseCategory: "Modifier une catégorie de cas",
  deleteCaseCategory: "Supprimer une catégorie de cas",
  caseCategoryName: "Nom de la catégorie de cas",
  caseCategoryDescription: "Description de la catégorie de cas",
  enterCaseCategoryName: "Entrer le nom de la catégorie de cas",
  enterCaseCategoryDescription: "Entrer la description de la catégorie de cas",
  editAnnouncement: "Modifier l'Annonce",
  tipoffs: "Signalements",
  casesOverview: 'Aperçu des Cas',
  institutionCases: "Cas par Institution",
  permissions: "Permissions",
  caseCategoriesSettings: "Paramètres des Catégories de Cas",
  createdAt: "Créé le",
  description: "Description",
  refreshAnalytics: "Actualiser les Analyse",
  analyticsRefreshed: "Analyse actualisée avec succès",
  errorRefreshingAnalytics: "Erreur lors de l'actualisation de l'analyse",
  organization: "Organisation",
  occupation: "Occupation",
  private: "Privé",
  noTimestamp: "Aucune marque de temps",
  theCaseWasMarkedAs: "Le cas a été marqué comme",
  theCaseWasEscalatedTo: "Le cas a été escaladé vers",
  escalatedTheCaseTo: "escaladé le cas vers",
  complaintType: 'Type de plainte',
  systemConfiguration: {
    title: 'Comment souhaitez-vous recevoir les notifications',
    description: 'Modifier les préférences de notification',
    label: 'Configuration du Système',
  },
  EAST: "EST",
  WEST: "OUEST",
  NORTH: "NORD",
  SOUTH: "SUD",
  KIGALI: "KIGALI",
  verifyComplaint: "Vérifier la Plainte",
  verify:'Vérifier',
  verifyUser: "Vérifier l'Utilisateur",
  verifyUserDescription: "Nous avons envoyé un code de vérification sur votre téléphone",
  provinceIsRequired: "La province est requise",
  districtIsRequired: "Le district est requis",
  sectorIsRequired: "Le secteur est requis",
  cellIsRequired: "La cellule est requise",
  villageIsRequired: "Le village est requis",
  titleIsRequired: "Le titre est requis",
  titleMaxLength: "Le titre doit contenir au maximum 250 caractères",
  complaintIsRequired: "La description de la plainte est requise",
  tipOffCategoryIsRequired: "La catégorie de signalement est requise",
  success: "Succès",
  caseNotFound: 'Votre plainte a été reçue et est en cours de traitement',
  goToHome: 'Aller à la page d\'accueil',
  trackComplaintNumber: 'Suivre la plainte #',
  noComplaintCode: "Aucun code de réclamation fourni",
  verificationCodeSentTo: 'Code de vérification envoyé à',
  toast: {
    error: "Erreur",
    success: "Succès",
    clipboard: "Numéro de l'application copié dans le presse-papiers"
  },
  menu: "Menu"
};

export default fr;
